<script setup lang="ts">
const { cacheState, isOffline } = useCache()
const { collectionFooterOfflineToastId } = useGlobals()
</script>

<template>
  <div
    v-if="isOffline()"
    :data-testid="collectionFooterOfflineToastId"
    class="toast"
  >
    <div v-if="['pendingAuth', 'pendingAnon'].includes(cacheState.status)">
      Currently offline, attempting to reconnect...
    </div>
    <div v-else-if="['disconnected'].includes(cacheState.status)">
      Contents unavailable offline
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.toast
  @apply bg-[#{$toast-bg-default}] h-6 flex items-center px-2.5 rounded-full t-menu-xs text-ellipses-inline backdrop-blur-$menu-blur-default backdrop-filter
</style>
